"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UIConfigSchema = exports.TaskSchema = void 0;
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const v4_1 = require("zod/v4");
exports.TaskSchema = tape_sanitizer_1.StackTransformationSchema.omit({
    srcDataTape: true,
    otherDataTapes: true,
}).extend({
    operation: v4_1.z.literal('stack'),
    srcArtifactSlug: v4_1.z.string(),
    otherArtifactSlugs: v4_1.z.array(v4_1.z.string()),
});
exports.UIConfigSchema = exports.TaskSchema.omit({
    srcArtifactSlug: true,
    otherArtifactSlugs: true,
});
exports.nodeType = 'operation_stack';
//# sourceMappingURL=types.js.map